module.exports = {"menu":{"drawingSystem":"ระบบบันทึก Drawing","drawingSystem2":"ระบบบันทึก Drawing 2","about":"รายละเอียด","master":"ข้อมูล เริ่มต้น","sellOrder":"ระบบันทึกแบบ Sale","user":"ผู้ใช้งาน","settings":"ตั้งค่า","systemSettings":"ระบบ"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/menu.json
// module id = 550
// module chunks = 14